import '@styles/pages/seller-page-contact.scss';

import { createApp } from 'vue';
import PageSpaceContactApp from './seller-page-contact/PageSpaceContactApp.vue';

createApp(PageSpaceContactApp)
  .mount('#space-contact-app');
